<div class="main-container">
  @if (user().loading) {
  <!-- Loading user -->
  <mat-sidenav-container class="main-container">
    <mat-sidenav-content>
      <div class="splash-wrapper">
        <mat-spinner></mat-spinner>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  } @else {
  @if (user().user !== null) {
  <!-- Logged In -->
  <mat-sidenav-container class="main-container" [hasBackdrop]="sideNav.opened">
    <mat-sidenav mode="over" #sideNav>
      <lh-side-nav></lh-side-nav>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="window-wrapper">
        <div class="top-nav">
          <lh-top-nav></lh-top-nav>
        </div>
        <div class="window-content">
          <mat-sidenav-container [hasBackdrop]="!isDesktop">
            <mat-sidenav-content>
              <router-outlet></router-outlet>
            </mat-sidenav-content>
            <mat-sidenav [mode]="!isDesktop ? 'over' : 'side'" #alertPanel position="end">
              <lh-alert-panel></lh-alert-panel>
            </mat-sidenav>
          </mat-sidenav-container>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  } @else {
  <!-- Logged Out -->
  <mat-sidenav-container class="main-container">
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
  }
  }

  <lh-toast></lh-toast>
</div>